module.exports = __webpack_public_path__ + "media/app/assets/races/gnome_male-f69ec36f477b62a143b09d5ccd447fd6.png";